import React, { useContext } from "react"
import useFetch from "../hooks/useFetch"
import StateContext from "./StateContext"
import UserContext from "./UserContext"

const StateProvider = (props) => {
  const { userData } = useContext(UserContext)
  const userId = userData.user.id

  const { data, loading: ledgerLoading, refetch: ledgerRefetch } = useFetch(`/ledger/user/${userId}`, { cache: true })

  const ledgerList = !data || ledgerLoading ? [] : data

  return <StateContext.Provider value={{ ledgerList, ledgerLoading, ledgerRefetch }}>{props.children}</StateContext.Provider>
}

export default StateProvider
